import "./product.css";
import React, { createRef, useEffect, useMemo, useRef, useState } from "react";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import CustomButton from "../../components/CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../getToken";
import authStore from "../../store/authStore";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { format, parseISO } from "date-fns";
import { message } from "antd";

const Product = () => {
  const refProductTable = useRef(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [keyword, setKeyword] = useState("");
  const refSelectMember = useRef();
  const productId = useRef(0);
  const [markerNameList, setMarkerNameList] = useState([]);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [detailProduct, setDetailProduct] = useState({
    marker_name: "",
    memberId: "",
    date: "",
    count: "",
    weight: "",
    rate: "",
    price: "",
    carry_name: "",
    description: ""
  });

  const brandId = authStore((state) => state.auth?.brandId);

  const clickAddProduct = () => {
    if (isEdit) {
      setIsEdit(false);
      setTimeout(() => setShowAddProduct(true), 100);
    } else {
      setShowAddProduct(true);
    }
    setIsView(false);
    getAllMemberMakerName();
    setDetailProduct({});
  };

  const clickEditProduct = async (e, id) => {
    setIsView(false);
    e.stopPropagation();
    clickBtnCloseForm();
    await getProductDetail(id);
  };

  const clickViewProduct = (rowData) => {
    setShowAddProduct(false);
    setIsEdit(false);
    setIsView(true);
    setDetailProduct({
      ...rowData,
      marker_name: rowData.markerName,
      date: format(parseISO(rowData.date), 'yyyy-MM-dd'),
      carry_name: rowData.carryName,
      productId: rowData.id,
    });
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickBtnCloseForm = () => {
    setShowAddProduct(false);
    setIsEdit(false);
    setIsView(false);
  };

  const getAllMemberMakerName = async () => {
    const data = await apiUtil.loadLookup(
      api,
      getToken,
      "Admin/GetMemberListByAdmin",
      {
        rowLimit: 1000,
        currentPage: 1,
        brandId
      }
    );

    setMarkerNameList(data);
  };

  const [productList, setProductList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramProduct, setParamProduct] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const markerNameSelectList = useMemo(() => {
    return markerNameList.map((x) => ({
      label: x.markerName,
      value: x.id,
    }));
  }, [markerNameList]);

  const retrieveProductList = async (value = paramProduct) => {
    const request = {
      ...value,
      keyword: value.keyword || "",
      sortBy: selectedOption ? selectedOption.value : "",
    };

    try {
      setProductList((prev) => ({
        ...prev,
        isLoading: true,
      }));

      const result = await api.post(
        "Admin/GetProductList",
        request,
        getToken()
      );

      apiUtil.parseResult(
        result,
        (response) => {
          const { code, data } = response.data;

          if (code === 401) {
            message.error(response.data.message);

            redirectToLogin();

            return;
          }

          if (code === 200) {
            setProductList((prev) => ({
              ...prev,
              isLoading: false,
              limit: data.rowLimit,
              data: data.data?.length ? data.data : [],
              total: data.totalRecords,
              page: data.paging,
            }));

            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });

            return;
          }

          setProductList((prev) => ({
            ...prev,
            data: [],
            total: 0,
            page: 0,
            limit: 0,
            isLoading: false,
          }));
        },
        (error) => {
          console.error(error);

          message.error("Failed to load product list.");

          setProductList((prev) => ({
            ...prev,
            data: [],
            total: 0,
            page: 0,
            limit: 0,
            isLoading: false,
          }));
        }
      );

    } catch (error) {
      console.error(error);

      message.error("Failed to load product list.");

      setProductList((prev) => ({
        ...prev,
        data: [],
        total: 0,
        page: 0,
        limit: 0,
        isLoading: false,
      }));
    }
  };

  const getProductDetail = async (id) => {
    try {
      await getAllMemberMakerName();

      const result = await api.get(
        "Admin/GetProductById",
        { productId: id },
        getToken()
      );

      apiUtil.parseResult(
        result,
        (response) => {
          const { code, data } = response.data;

          if (code === 401) {
            message.error(response.data.message);

            redirectToLogin();

            return;
          }

          if (code === 200) {
            setDetailProduct({
              ...data,
              marker_name: data.markerName,
              date: data.date
                ? format(parseISO(data.date), "yyyy-MM-dd")
                : "",
              carry_name: data.carryName,
            });

            productId.current = id;

            setIsEdit(true);

            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });

            return;
          }

          message.warning(response.data.message);
        },
        (error) => {
          console.error(error);
          message.error("Failed to load product detail.");
        }
      );

    } catch (error) {
      console.error(error);
      message.error("Failed to load product detail.");
    }
  };

  // Add Product Validation Form
  const AddProductValidation = Yup.object().shape({
    marker_name: Yup.string().required("Please select the maker name."),
    date: Yup.date().required("Please select the date."),
    count: Yup.string().required("Please enter the quantity."),
    weight: Yup.string().required("Please enter the weight."),
    rate: Yup.string().required("Please enter the rate."),
    price: Yup.string().required("Please enter the price."),
    carry_name: Yup.string().required("Please enter the carry name."),
  });

  const submitProductHandler = async (values, actions) => {
    const isUpdate = isEdit;

    const product = {
      ...(isUpdate && {
        id: productId.current,
      }),
      brandId: brandId,
      memberId: values.marker_name,
      markerName: values.marker_name,
      date: isUpdate
        ? values.date
        : format(parseISO(values.date), "yyyy-MM-dd"),
      count: values.count,
      weight: values.weight,
      rate: values.rate,
      price: values.price,
      carryName: values.carry_name,
      description: values.description
    };

    const apiUrl = isUpdate
      ? "Admin/UpdateProduct"
      : "Admin/CreateProduct";

    try {
      const result = await api.post(
        apiUrl,
        product,
        getToken()
      );

      apiUtil.parseResult(
        result,
        (response) => {

          if (response.data.code === 409) {
            message.warning("Marker Name is already in used.");
            return;
          }

          if (response.data.code === 200) {

            message.success(
              isUpdate
                ? "Product updated successfully!"
                : "Product saved successfully!"
            );

            actions.resetForm();

            setIsEdit(false);
            setShowAddProduct(false);

            retrieveProductList();
          }

          else if (response.data.statusCode === 401) {

            message.error(response.data.value.message);

            redirectToLogin();

          } else {
            message.warning(response.data.message);
          }

        },
        () => {
          message.error(
            isUpdate
              ? "An error occurred while updating the product."
              : "An error occurred while saving the product."
          );
        }
      );

    } catch (error) {

      console.log(error);

      message.error(
        isUpdate
          ? "An error occurred while updating the product."
          : "An error occurred while saving the product."
      );
    }
    finally {
      actions.setSubmitting(false);
    }
  };

  useEffect(() => {
    retrieveProductList({
      ...paramProduct,
      keyword
    });
  }, [paramProduct.currentPage]);

  let pageTitle;
  if (showAddProduct) {
    pageTitle = "Add Product";
  } else if (isEdit) {
    pageTitle = "Edit Product";
  } else {
    pageTitle = "Product Detail";
  }

  return (
    <>
      {(showAddProduct || isEdit || isView) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">{pageTitle}</h6>
            <button className="btn btnClose" onClick={clickBtnCloseForm}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          {showAddProduct || isEdit ? (
            <Formik
              initialValues={{
                marker_name: detailProduct.marker_name,
                memberId: detailProduct.memberId,
                date: detailProduct.date,
                count: detailProduct.count,
                weight: detailProduct.weight,
                rate: detailProduct.rate,
                price: detailProduct.price,
                carry_name: detailProduct.carry_name,
                description: detailProduct.description
              }}
              validationSchema={AddProductValidation}
              validateOnBlur={false}
              onSubmit={submitProductHandler}
            >
              {({ errors, touched, values, setFieldValue, isSubmitting }) => (
                <Form className="row form-container add-product-point-form">
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="date"
                      type="date"
                      label="Date"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomSelect
                      options={markerNameSelectList}
                      name="marker_name"
                      label="Marker Name"
                      isclearable={false}
                      placeholder="Select Marker Name"
                      refSelect={refSelectMember}
                      onChange={(selectedOption) => {
                        setFieldValue("marker_name", selectedOption ? selectedOption.value : "");
                      }}
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="count"
                      type="number"
                      label="Quantity"
                      customclass="input_wrapper"
                      hideicon="true"
                      isclearable={true}
                      placeholder="Quantity"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="weight"
                      type="number"
                      label="Weight (kg)"
                      step="0.1"
                      customclass="input_wrapper"
                      placeholder="Weight"
                      hideicon="true"
                      value={values.weight || ""}
                      onChange={(value) => {
                        const numericWeight = parseFloat(value) || 0;
                        const numericRate = parseFloat(values.rate) || 0;
                        const calculatedPrice = numericWeight * numericRate;

                        setFieldValue("weight", value);
                        setFieldValue("price", calculatedPrice.toFixed(2));
                      }}
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="rate"
                      type="number"
                      step="0.1"
                      label="Rate"
                      placeholder="Rate"
                      customclass="input_wrapper"
                      hideicon="true"
                      value={values.rate || ""} // Controlled input
                      onChange={(value) => {
                        const numericWeight = parseFloat(values.weight) || 0;
                        const numericRate = parseFloat(value) || 0;
                        const calculatedPrice = numericWeight * numericRate;

                        setFieldValue("rate", value);
                        setFieldValue("price", calculatedPrice.toFixed(2)); // Set calculated price
                      }}
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="price"
                      type="number"
                      label="Price"
                      placeholder="Calculated price"
                      customclass="input_wrapper"
                      hideicon="true"
                      value={values.price || ""} // Controlled value
                      readOnly // Mark price as read-only
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="carry_name"
                      type="text"
                      label="Carry Name"
                      placeholder="Carry Name"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="description"
                      type="text"
                      label="Note"
                      placeholder="Note"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>

                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnCloseForm}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnAddPM" disabled={isSubmitting}>
                        {isSubmitting
                          ? "Saving..."
                          : showAddProduct
                            ? "Create"
                            : "Update"
                        }
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          ) : null}

          {isView && (
            <>
              <Formik
                initialValues={detailProduct}
                validateOnBlur={false}
              >
                {({ errors, touched, setFieldValue }) => (
                  <Form className="row form-container add-product-point-form">
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="date"
                        type="date"
                        label="Date"
                        value={new Date(detailProduct.date).toLocaleDateString("eng-US")}
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="marker_name"
                        label="Marker Name"
                        isclearable={false}
                        placeholder="Marker Name"
                        readOnly
                        hideicon="true"
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="count"
                        type="number"
                        label="Quantity"
                        customclass="input_wrapper"
                        hideicon="true"
                        isclearable={true}
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="weight"
                        type="number"
                        step="0.1"
                        label="Weight (kg)"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="rate"
                        type="number"
                        step="0.1"
                        label="Rate"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="price"
                        type="number"
                        label="Price"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="carry_name"
                        type="text"
                        label="Carry Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="description"
                        type="text"
                        label="Note"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Product</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}

          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={(value) =>
              retrieveProductList({
                ...paramProduct,
                keyword: value || "",
                currentPage: 1
              })
            }
          />
          {!showAddProduct && (
            <CustomButton
              icon={add}
              text="Add Product"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddProduct}
            />
          )}
        </div>
      </div>

      <div className="table_container product_table">
        <Table
          ref={refProductTable}
          maxBodyHeight={productList.limit * 100}
          isLoading={productList.isLoading}
          grouping={productList.grouping}
          limit={productList.limit}
          page={productList.page}
          total={productList.total}
          data={productList.data}
          onPageChange={(page) => {
            setParamProduct(prev => ({
              ...prev,
              currentPage: page,
            }));
          }}
          columns={[
            {
              title: "No",
              render: (row) => row.tableIndex + 1
            },
            {
              title: "Date",
              render: (row) => {
                return row.date ? format(parseISO(row.date), 'dd-MM-yyyy') : "-"
              },
              width: "100"
            },
            {
              title: "Marker",
              field: "markerName"
            },
            {
              title: "Quantity",
              field: "count"
            },
            {
              title: "Weight (kg)",
              field: "weight"
            },
            {
              title: "Rate",
              field: "rate",
            },
            {
              title: "Price",
              render: (row) => {
                return Number(row.price).toLocaleString();
              }
            },
            {
              title: "Carry Name",
              field: "carryName",
              width: "200"
            },
            {
              title: "Note",
              field: "description",
              width: "200"
            },
            {
              title: "Edit",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="editIcon"
                    onClick={(e) => clickEditProduct(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
            {
              title: "View",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="viewIcon"
                    onClick={() => clickViewProduct(row)}
                  >
                    <img src={view} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
          ]}
        />
      </div>
    </>
  )
}
export default Product;
